"use strict";

define('rs/models/sponsor',['rs/models/abstract', 'rs/models/contact', 'rs/helper'], function (AbstractModel, ContactModel, helper) {
  var SponsorModel = AbstractModel.extend({
    properties: ['activityDate', 'contacts', 'preferredPhone', 'secondaryPhone', 'sponsors', 'updateUserAuthId'],
    serverProperties: ['acronym', 'address', 'childIds', 'equityInOrganization', 'hide', 'id', 'name', 'parentId', 'sponsorCategoryId', 'sponsorCode', 'telephones', 'version'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setSponsors(this.sponsors || []);
      this.setTelephones(this.telephones || []);
    },
    setTelephones: function setTelephones() {
      var ret = this._super.apply(this, arguments);
      this.loadPreferredPhoneNumber();
      return ret;
    },
    loadPreferredPhoneNumber: function loadPreferredPhoneNumber() {
      var phones = this.getTelephones().slice(0) || [],
        primary = null,
        primaryIndex = null,
        secondary = null;
      primary = _.find(phones, function (phone, index, list) {
        primaryIndex = index;
        return phone.preferred == true || list.length == 1 || index == list.length - 1;
      });
      if (primary) {
        phones.splice(primaryIndex, 1);
      }
      secondary = phones[0];
      this.setPreferredPhone(primary);
      this.setSecondaryPhone(secondary);
    },
    findSponsor: function findSponsor(id) {
      return helper.findObjectByProperty(this, 'sponsors', 'id', id);
    },
    getFilteredSponsorsList: function getFilteredSponsorsList(id) {
      var flatList = [],
        _retrieveFlatList = function retrieveFlatList(n) {
          var children = n.getSponsors();
          for (var i = 0; i < children.length; i++) {
            if (children[i].getId() == id) {
              continue;
            }
            flatList.push(children[i]);
            _retrieveFlatList(children[i]);
          }
        };
      _retrieveFlatList(this);
      return flatList;
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDeleteSponsor(this.getId());
    },
    requestDetails: function requestDetails() {
      if (this.hasDetails) {
        return Promise.resolve(this);
      } else {
        return this.constructor.requestDetails(this.getId()).bind(this).then(function (data) {
          this.hasDetails = true;
          data.contacts = ContactModel.models(data.contacts);
          this.applyProperties(data);
          return Promise.resolve(this);
        });
      }
    },
    requestNewSponsor: function requestNewSponsor(data) {
      return this.constructor.requestCreateSponsor(data).bind(this).tap(function (sponsor) {
        if (sponsor instanceof SponsorModel) {
          this.sponsors.push(sponsor);
        }
      });
    },
    requestSponsors: function requestSponsors(data) {
      return this.constructor.requestSponsorHierarchy(this.getId()).bind(this).tap(function (sponsors) {
        this.setSponsors(sponsors);
      });
    },
    requestSponsorsByType: function requestSponsorsByType(type) {
      return this.constructor.requestSponsorList().bind(this).tap(function (sponsors) {
        sponsors = _.filter(sponsors, function (sponsor) {
          return sponsor.categoryId == type;
        });
        this.setSponsors(sponsors);
      });
    },
    requestUpdate: function requestUpdate(newValues) {
      this.hasDetails = false;
      this.applyProperties(newValues);
      return this.constructor.requestSponsorUpdate(this).bind(this).tap(function (data) {
        this.hasDetails = true;
        this.applyProperties(data);
      });
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      'sponsor/:id': function sponsor_Id(data) {
        return data;
      },
      '#get#sponsor(?*query)': function getSponsorQuery(data, params) {
        return this.models(data);
      },
      '#post#sponsor': function postSponsor(data) {
        return this.model(data);
      }
    },
    model: function model(data) {
      data.sponsors = _.map(data.children, function (sponsor) {
        return SponsorModel.model(sponsor, data.id);
      });
      data.contacts = ContactModel.models(data.contacts);
      delete data.children;
      return new SponsorModel(data);
    },
    getRoot: function getRoot() {
      return new this({
        id: null,
        name: 'Root Sponsor'
      });
    },
    requestCreateSponsor: function requestCreateSponsor(data) {
      return this.post('sponsor', data, {
        jsonBody: true
      });
    },
    requestDeleteSponsor: function requestDeleteSponsor(id) {
      return this.del('sponsor/' + id);
    },
    requestDetails: function requestDetails(id) {
      return this.get('sponsor/' + id);
    },
    requestSponsorHierarchy: function requestSponsorHierarchy(id) {
      var params = {};
      params.v = 'hierarchy';
      if (id) {
        param.id = id;
      }
      return this.get('sponsor', params);
    },
    requestSponsorList: function requestSponsorList(qstr, limit, page) {
      var paramObj = {};
      paramObj.v = 'flat';
      if (qstr) {
        paramObj.q = qstr;
      }
      if (limit) {
        paramObj.n = limit;
      }
      if (page) {
        paramObj.s = page;
      }
      return this.get('sponsor', paramObj);
    },
    requestSponsorUpdate: function requestSponsorUpdate(model) {
      return this.put('sponsor/' + model.getId(), model);
    }
  });
  return SponsorModel;
});

